"use client";

import { Button, Grid } from "@mui/material";
import Link from "next/link";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import useCart from "src/lib/components/salify-next-layout/default/hooks/useCart";
import PaymentForm from "./payment-form";
import CheckoutSummary from "../step-checkout/checkout-summery";

const CardSectionStepPayment = (
  props: React.PropsWithChildren<{ nextUrl: string; backUrl: string }>,
) => {
  const { state } = useCart();

  return (
    <Grid container spacing={3}>
      <Grid item md={8} xs={12}>
        <PaymentForm />

        <Grid container spacing={6} sx={{ pt: 4 }}>
          <Grid item sm={6} xs={12}>
            <Button
              LinkComponent={Link}
              variant="outlined"
              color="primary"
              type="button"
              href={props.backUrl}
              fullWidth
            >
              <SalifyFallback.Label path="Back to Checkout" default="Quay lại" />
            </Button>
          </Grid>

          <Grid item sm={6} xs={12}>
            <Button
              LinkComponent={Link}
              variant="contained"
              color="primary"
              type="button"
              href={props.nextUrl}
              fullWidth
            >
              <SalifyFallback.Label path="Review" default="Tiếp tục" />
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4} xs={12}>
        <CheckoutSummary />
      </Grid>
    </Grid>
  );
};

export default CardSectionStepPayment;
